import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { avoid } from './shared/avoid'
import { videoLength } from './shared/videoLength'
import { promotion } from './shared/promotion'
import { callToAction } from './shared/callToAction'
import { Instagram } from 'blaze-ui/icons'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.InstagramReel,
  icon: Instagram,
  steps: ['Context', 'Generate Reel Script'],
  title: TextChannels[ChannelType.InstagramReel].name,
  submitLabel: 'Generate Reel Script',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183788/Home%20Card%20Previews/fkutrbifu9q9h8dpccjp.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your Instagram Reel Script?', generationType: meta.type }),
  video_length: videoLength
    .oneOf(['Less than 30 seconds', '30 to 60 seconds', 'More than 60 seconds'])
    .required()
    .default('30 to 60 seconds'),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  language,
  include_images: includeImages.meta({
    description: 'An image will make your reels far more engaging and attention grabbing',
  }),
  promotion: promotion.meta({ collapsible: true }),
  call_to_action: callToAction.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const InstagramReelsSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const InstagramReelsMultiStepSchema: MultiStepSchema<ChannelType.InstagramReel> = {
  steps: [
    InstagramReelsSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.InstagramReel,
    channel: ChannelType.InstagramReel,
  },
}
